const text = `產險業履行個人資料保護法告知義務內容

美商安達產物保險股份有限公司台灣分公司（以下稱本公司）依據個人資料保護法（以下稱個資法）第八條第一項（如為間接蒐集之個人資料則為第九條第一項）規定，向　台端告知下列事項，請　台端詳閱： 

一、蒐集之目的： 
財產保險（093）、人身保險（001）、行銷(040)、金融服務業依法令規定及金融監理需要，所為之蒐集處理及利用(059)、非公務機關依法定義務所進行個人資料之蒐集處理及利用(063)、契約、類似契約或其他法律關係事務(069)、消費者、客戶管理與服務(090)、消費者保護(091)、網路購物及其他電子商務服務(148)、調查、統計與研究分析(157)、其他經營合於營業登記項目或組織章程所定之業務(181)。
二、蒐集之個人資料類別：
（一）姓名；（二）身分證統一編號；（三）聯絡方式；（四）其他：詳如相關業務申請書或契約書內容。
三、個人資料來源（個人資料非由當事人提供，而為間接蒐集之情形適用）
（一）要保人/被保險人；
（二）司法警憲機關、委託協助處理理賠之公證人或機構；
（三）當事人之法定代理人、輔助人；
（四）各醫療院所；
（五）與第三人共同行銷、交互運用客戶資料、合作推廣等關係、或於本公司各項業務內所委託往來之第三人。
四、個人資料利用之期間、對象、地區及方式：
（一）期間：因執行業務所必須及依法令規定應為保存之期間，或另經 台端書面同意之期間，以期限最長者為準。
（二）對象：本公司、本公司之總公司、本公司所屬安達集團之母公司及海外關係企業或分支機構、中華民國產物保險商業同業公會、中華民國人壽保險商業同業公會、財團法人保險事業發展中心、財團法人保險安定基金、財團法人住宅地震保險基金、財團法人汽車交通事故特別補償基金、財團法人金融消費評議中心、財團法人金融聯合徵信中心、財團法人聯合信用卡中心、台灣票據交換所、財金資訊公司、關貿網路股份有限公司、衛生福利部中央健康保險署、業務委外機構、與本公司有再保業務往來之公司、與本公司合作推廣您保險契約之保險代理人公司/保險經紀人公司 (透過保險代理人公司或保險經紀人公司投保者)、與本公司合作辦理銀行保險業務之銀行、與本公司依法辦理異業合作推廣附屬性保險商品業務之機構、台端所同意之對象(例如與本公司依法辦理共同行銷或交互運用客戶資料之機構等)、依法有調查權機關或金融監理機關、本公司之總公司或母公司之監理或主管機關、本公司或本公司之總公司、母公司或海外關係企業或分支機構所使用之服務供應商、未受中央目的事業主管機關限制之國際傳輸個人資料之接收者。
（三）地區：上述對象所在之地區(國內及國外)。
（四）方式：合於法令規定之利用方式。
五、依據個資法第三條規定，台端就本公司保有  台端之個人資料得行使之權利及方式：
（一）得向本公司行使之權利
1. 向本公司查詢、請求閱覽或請求製給複製本。
2. 向本公司請求補充或更正。
3. 向本公司請求停止蒐集、處理或利用及請求刪除。
（二）行使權利之方式：以書面或客服專線（0800-505-966）通知本公司。
六、台端不提供個人資料所致權益之影響（個人資料由當事人直接蒐集之情形適用）：
台端若未能提供相關個人資料時，本公司將可能延後或無法進行必要之審核及處理作業，因此可能婉謝承保、遲延或無法提供  台端相關服務或給付。
七、本公司依法令或配合安達集團相關政策及為強化個人資料管理及保護，將可能隨時修訂本告知事項，台端同意本公司有權修訂此告知事項，並同意本公司於本告知事項修訂後，得以<a href="https://www.chubb.com/tw-zh/" target="_blank" rel="noopener noreferrer">官網</a>公告或其他足以使台端知悉或可得知悉之方式告知(包括但不限於以提供詳載本告知事項內容之網站連結供 台端詳閱)。
八、如台端與本公司先前簽訂之契約或文件所訂定或約定與個人資料之蒐集、處理、利用、國際傳輸有關之條款與本告知事項有所歧異者，以本告知事項及其後本公司修訂之版本為準。

【註】：上開告知事項已公告於本公司<a href="https://www.chubb.com/tw-zh/" target="_blank" rel="noopener noreferrer">官網</a>，內容若有更動，請以官網公告版本為準。如有任何問題歡迎洽詢本公司客服專線（0800-505-966）。
`;

export default text;
